import * as yup from 'yup';
import { resetPassword as TEXT } from 'locales/en';

const schema = yup.object().shape({
  email: yup
    .string()
    .email(TEXT.errors.email.invalid)
    .required(TEXT.errors.email.required),
  password: yup
    .string()
    .min(8, TEXT.errors.password.min)
    .required(TEXT.errors.password.required),
  password_confirmation: yup
    .string()
    .required(TEXT.errors.password_confirmation.required)
    .test(
      'passwords-match',
      TEXT.errors.password_confirmation.match,
      function (value) {
        return this.parent.password === value;
      }
    ),
});

export default schema;
